export const Languages = ['en', 'tr'];
export const DefaultLang = 'tr';
